import { useTopOfPageContent } from "@faire/retailer-visitor-shared/stores/ui/useTopOfPageContent";
import { debounceIfPossible } from "@faire/web--source/common/globals/debounceIfPossible";
import { getWindowOrThrow } from "@faire/web--source/common/globals/getWindow";
import { useMemo, useRef } from "react";
export var useCategoryPageScroll = function() {
    var scrollRef = useRef(null);
    var filterRef = useRef(null);
    var headerPlusPromoBannerHeight = useTopOfPageContent().headerPlusPromoBannerHeight;
    var scrollToTop = useMemo(function() {
        return debounceIfPossible(function(params) {
            var _filterRef_current, _scrollRef_current, _getWindowOrThrow_scrollTo, _getWindowOrThrow;
            var height = headerPlusPromoBannerHeight;
            var offsetTop = 0;
            if (params.toTop) {
                offsetTop = 0;
            } else if (params.toResults && ((_filterRef_current = filterRef.current) === null || _filterRef_current === void 0 ? void 0 : _filterRef_current.offsetTop)) {
                offsetTop = filterRef.current.offsetTop - height;
            } else if ((_scrollRef_current = scrollRef.current) === null || _scrollRef_current === void 0 ? void 0 : _scrollRef_current.offsetTop) {
                offsetTop = scrollRef.current.offsetTop - height;
            }
            (_getWindowOrThrow_scrollTo = (_getWindowOrThrow = getWindowOrThrow()).scrollTo) === null || _getWindowOrThrow_scrollTo === void 0 ? void 0 : _getWindowOrThrow_scrollTo.call(_getWindowOrThrow, {
                top: offsetTop,
                left: 0,
                behavior: "smooth"
            });
        }, 100);
    }, [
        headerPlusPromoBannerHeight
    ]);
    return {
        scrollRef: scrollRef,
        filterRef: filterRef,
        scrollToTop: scrollToTop
    };
};
